import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Briefcase, Settings, Image } from 'lucide-react';
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';
const DashboardOverview = () => {
    const [profileData, setProfileData] = useState({ name: '', email: '' });
    const [stats, setStats] = useState({
        slides: 0,
        blog: 0,
        portfolio: 0,
        services: 0,
    });
    useEffect(() => {
        // Load user data
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const user = JSON.parse(userStr);
                setProfileData({ name: user.name || '', email: user.email || '' });
            }
            catch (e) {
                console.error('Error parsing user data:', e);
            }
        }
        const fetchStats = async () => {
            const token = localStorage.getItem('token');
            const headers = {
                'Authorization': `Bearer ${token}`,
            };
            try {
                const [slides, blog, portfolio, services] = await Promise.all([
                    fetch(`${API_URL}/slides/all`, { headers }).then(r => r.json()),
                    fetch(`${API_URL}/blog/all`, { headers }).then(r => r.json()),
                    fetch(`${API_URL}/portfolio/all`, { headers }).then(r => r.json()),
                    fetch(`${API_URL}/services/all`, { headers }).then(r => r.json()),
                ]);
                setStats({
                    slides: slides.length,
                    blog: blog.length,
                    portfolio: portfolio.length,
                    services: services.length,
                });
            }
            catch (error) {
                console.error('Failed to fetch stats:', error);
            }
        };
        fetchStats();
    }, []);
    const cards = [
        { title: 'Slides', value: stats.slides, icon: Image, color: 'text-blue-500' },
        { title: 'Blog Posts', value: stats.blog, icon: FileText, color: 'text-green-500' },
        { title: 'Portfolio Items', value: stats.portfolio, icon: Briefcase, color: 'text-purple-500' },
        { title: 'Services', value: stats.services, icon: Settings, color: 'text-orange-500' },
    ];
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/admin/login';
    };
    return (_jsxs("div", { children: [_jsx("h1", { className: "text-3xl font-bold mb-8", children: "Dashboard Overview" }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6", children: cards.map((card) => (_jsxs(Card, { children: [_jsxs(CardHeader, { className: "flex flex-row items-center justify-between pb-2", children: [_jsx(CardTitle, { className: "text-sm font-medium", children: card.title }), _jsx(card.icon, { className: `h-4 w-4 ${card.color}` })] }), _jsx(CardContent, { children: _jsx("div", { className: "text-2xl font-bold", children: card.value }) })] }, card.title))) })] }));
};
export default DashboardOverview;
